export const DEALER_LOCATOR_FILTER_TYPES = {
  BUSINESS_CODE: 'BusinessCode',
  CATEGORY_CODE: 'CategoryCode',
}

export const DEALER_DEPARTMENT_CODE_GENERAL = 'GEN'
